<!-- Alerts Container -->
<div class="alerts-container">
    @for (alert of alerts; track alert.id) {
      <div
        [@slideInOut]="alert.message ? 'open' : 'closed'"
        class="alert-wrapper"
        [ngClass]="{
          'alert-success': alert.type === 'success',
          'alert-error': alert.type === 'error',
          'alert-info': alert.type === 'info',
          'alert-warning': alert.type === 'warning',
        }"
      >
        <div
          class="alert-icon-wrapper"
          [ngClass]="{
            'alert-success-icon-wrapper': alert.type === 'success',
            'alert-error-icon-wrapper': alert.type === 'error',
            'alert-info-icon-wrapper': alert.type === 'info',
            'alert-warning-icon-wrapper': alert.type === 'warning',
          }"
        >
          <app-icon [icon]="alertIcons[alert.type]"></app-icon>
          <div>{{ alertTitleMapper[alert.type] }}</div>
        </div>
        <div class="alert-message-wrapper">
          {{ alert.message }}
        </div>
        <div class="alert-close-wrapper">
          <app-icon
            [hoverClass]="
              'alert-close-hover-effect ' +
              (alert.type === 'success'
                ? 'alert-success-close-hover-effect'
                : '') +
              (alert.type === 'error' ? 'alert-error-close-hover-effect' : '') +
              (alert.type === 'info' ? 'alert-info-close-hover-effect' : '') + 
              (alert.type === 'warning' ? 'alert-warning-close-hover-effect' : '')
            "
            [icon]="'CLOSE'"
            (click)="closeAlert(alert.id)"
          ></app-icon>
        </div>
      </div>
    }
  </div>
  